const paymentMixin = {
  props: {
    disabled: Boolean,
    showed: {
      type: Boolean,
      default: true,
    },
    country: {
      type: String,
      default: process.env.VUE_APP_PAYMENT_COUNTRY_CODE,
    },
    currency: {
      type: String,
      default: "EUR",
    },
    amount: {
      type: Number,
      default: 0,
    },
    description: {
      type: String,
      default: "",
    },
    clientPaysFee: {
      type: Boolean,
      default: false,
    },
    qrCodes: {
      type: Array,
      default: () => {
        return [];
      },
    },
    paymentObject: {
      type: Array,
      default: () => {
        return [];
      },
    },
    business: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: () => ({
    fullScreenLoading: false,
  }),
};

export default paymentMixin;
